import { render, staticRenderFns } from "./rewrite.vue?vue&type=template&id=3e0874cc&scoped=true"
import script from "./rewrite.vue?vue&type=script&lang=js"
export * from "./rewrite.vue?vue&type=script&lang=js"
import style0 from "./rewrite.vue?vue&type=style&index=0&id=3e0874cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0874cc",
  null
  
)

export default component.exports